<div class="background-image-container mt-ncs">
  <div class="container">
    <div class="home-news-content py-4 px-2 py-sm-5 px-sm-0 mt-0 mb-4">
      @if (homeNewsMetadataValue$ | async; as homeNewsMetadataValue) {
        <div class="container">
          <div class="jumbotron jumbotron-fluid bg-transparent text-white">
            <ds-markdown-viewer [value]="homeNewsMetadataValue"></ds-markdown-viewer>
          </div>
        </div>
      }
      @else {
        <div class="row align-items-center">
          <div class="col-lg-12 text-center text-lg-start">
            <span class="badge bg-primary mb-2 px-3 py-2 text-uppercase tracking-wider">AVINUTYSPACE</span>
            <h1 class="display-4 fw-bold text-white mb-3">
              Institutional Repository
            </h1>
            <p class="lead text-white-50 mb-4">
              Avinashilingam Institute for Home Science and Higher Education for Women, Coimbatore
            </p>
            <p class="text-light mb-4">
              A digital archive showcasing the scholarly research, doctoral dissertations, research publications, rare manuscripts, and institutional assets produced by the faculty, scholars, and students of the Institute.
            </p>
            
            <div class="d-flex flex-wrap gap-3 mt-4">
              <a href="/search" class="btn btn-primary btn-lg px-4 me-md-2">
                <i class="fas fa-search me-2"></i>Explore Collections
              </a>
              <a href="/community-list" class="btn btn-outline-light btn-lg px-4">
                <i class="fas fa-layer-group me-2"></i>Browse Communities
              </a>
            </div>
          </div>
        </div>
      }
    </div>
  </div>

  <!-- Updated Banner Image -->
  <picture class="background-image">
    <img alt="Avinashilingam Institute Department Banner"
         src="https://avinuty.ac.in/sites/avinuty.ac.in/files/styles/department_banner/public/2023-09/chuttersnap-Zf64Osndqvc-unsplash.jpg" />
  </picture>
</div>